import { render, staticRenderFns } from "./ExternalConfirmationSection.vue?vue&type=template&id=686b0f48&scoped=true"
import script from "./ExternalConfirmationSection.vue?vue&type=script&lang=ts"
export * from "./ExternalConfirmationSection.vue?vue&type=script&lang=ts"
import style0 from "./ExternalConfirmationSection.vue?vue&type=style&index=0&id=686b0f48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686b0f48",
  null
  
)

export default component.exports